import { useCallback, useEffect, useState } from "react";

import { track } from "./analytics";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Hero } from "./components/Hero";
import { Invitation } from "./components/Invitation";
import { Loader } from "./components/Loader";
import { Nav } from "./components/Nav";
import { Origin } from "./components/Origin";
import { Practice } from "./components/Practice";
import { Recognition } from "./components/Recognition";
import { Ripple } from "./components/Ripple";
import { Science } from "./components/Science";
import { SectionDivider } from "./components/SectionDivider";
import { useSmoothScroll } from "./hooks/useSmoothScroll";

const INTRO_SEEN_KEY = "vy-nz-intro-seen";

export function App() {
  // The loader is an arrival moment, not a toll — it plays once per
  // browser session. Returning from /events (full page loads, no SPA
  // router) skips straight to the page.
  const [ready, setReady] = useState(
    () => sessionStorage.getItem(INTRO_SEEN_KEY) === "1",
  );
  useSmoothScroll();

  useEffect(() => {
    track("home_viewed");
  }, []);

  // Cross-page anchors (/#contact, /#practice from other routes) land
  // here as a hash on a fresh load. Once content is on screen, carry
  // the visitor to the section they asked for.
  useEffect(() => {
    if (!ready) {
      return;
    }
    const hash = window.location.hash.replace(/^#/, "");
    if (!hash) {
      return;
    }
    requestAnimationFrame(() => {
      document
        .getElementById(hash)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [ready]);

  const handleLoaded = useCallback(() => {
    sessionStorage.setItem(INTRO_SEEN_KEY, "1");
    setReady(true);
  }, []);

  return (
    <>
      {!ready && <Loader onComplete={handleLoaded} />}
      <Nav tone="light" />
      <main>
        <Hero />
        <Recognition />
        {/* Swamiji + the Mahamandir lifted higher — the lineage is
            the foundation, not a closing note. Recognition + Origin are
            both bg-cream, so no transitioning divider between them. */}
        <Origin />
        <SectionDivider from="cream" to="cream-dark" />
        <Invitation />
        <SectionDivider from="cream-dark" to="cream" />
        <Practice />
        <SectionDivider from="cream" to="cream-dark" />
        <Science />
        <Ripple />
        <SectionDivider from="cream-dark" to="cream" />
        <div id="contact" className="scroll-mt-32">
          <Contact />
        </div>
      </main>
      <Footer />
    </>
  );
}
